import { render, staticRenderFns } from "./APTabe.vue?vue&type=template&id=440117dd"
import script from "./APTabe.vue?vue&type=script&lang=js"
export * from "./APTabe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports